/* eslint-disable keyword-spacing */
import { types } from './sidebar.types';

const DEFAULT_COLLAPSED_WIDTH = 1439;

const initialSate = {
    popover: {
        content: '',
        isShowing: false,
        namedLists: {}
    },
    collapsed: !(window.innerWidth <= DEFAULT_COLLAPSED_WIDTH),
};

const addNamedList = (currentLists, name, content) => {
    // Return a new object to avoid mutating state
    return {
        ...currentLists,
        [name]: content
    };
};

const sidebar = (state = initialSate, { type, payload }) => {
    switch (type) {
    case types.SET_POPOVER_CONTENT:
        return {
            ...state,
            popover: {
                ...state.popover,
                content: payload,
            }
        };

    case types.SHOW_POPOVER_CONTENT:
        return {
            ...state,
            popover: {
                ...state.popover,
                isShowing: true,
            }
        };

    case types.CLOSE_POPOVER:
        return {
            ...state,
            popover: {
                ...state.popover,
                isShowing: false,
            }
        };

    case types.SET_NAMED_LIST:
        return {
            ...state,
            popover: {
                ...state.popover,
                namedLists: addNamedList(state.popover.namedLists, payload.name, payload.content)
            }
        };
    case types.TOGGLE_SIDEBAR_COLLAPSE:
        return {
            ...state,
            collapsed: payload,
        };

    default:
        return state;
    }
};

export default sidebar;
